import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ListItemText, MenuItem, Typography } from '@mui/material'
import { RouteImage } from '../../../../../assets/routeImage'
import { useDispatch, useSelector } from 'react-redux'
import { NavigateFunction, useNavigate } from 'react-router-dom'

// COMPONENT
import Navbar from '../../../Navbar'
import Header from '../../../Header'
import { ButtonOutlined } from '../../../../../component/mui-custom/MuiCustom'
import * as styled from '../../../style/main.style'
import TableCustom from '../../../../../component/table/tableCustom'
import TableRowCommon from '../../../../../component/table/TableRowCommon'
import HeaderTopicTable from '../../../../../component/header-table/HeaderTopicTable'
import { disableStyleButtonMui } from '../../../../../utils/disableStyleButton'
import ModalCustom from '../../../../../component/modal/ModalCustom'
import AddStrategy from './add-strategies/AddStrategy'
import EditStrategy from './edit-strategies/EditStrategy'
import Loading from '../../../../../component/loading/Loading'

// API
import { StrategyApi, getStrategy, updateStrategy } from '../../../../../api/strategy/strategy.api';
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice'
import FilterSelect from '../../../../../component/select/filterSelect'
import { swalError } from '../../../../../component/notification/swal'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

type Props = {}
const Strategic: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const idFiscalYear = useSelector((state: any) => state?.fiscalYear?.idFiscalYear);
    const permission = useSelector((state: any) => state?.permission?.permission);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalItems, setTotalItems] = useState<number>(Number);
    const [isShowModal, setIsShowModal] = useState<boolean>(false);
    const [isShowModalEdit, setIsShowModalEdit] = useState<boolean>(false);
    const [strategy, setStrategy] = useState<any[]>([]);
    const [idStrategyRef, setIdStrategyRef] = useState<number>(Number);
    const [idStrategy, setIdStrategy] = useState<number>(Number);

    const handleToggleModal = () => setIsShowModal(!isShowModal)
    const handleToggleModalEdit = () => setIsShowModalEdit(!isShowModalEdit)

    // API
    const handleChangeStatusStrategy = async (idStrategy: number, objData: any, strategyStatus: string) => {
        dispatch(setLoading())
        let condition: updateStrategy = {
            idFiscalYear: objData?.idFiscalYear,
            idStrategyRef: objData?.idStrategyRef,
            strategyDesc: objData?.strategyDesc,
            strategyName: objData?.strategyName,
            strategyNo: objData?.strategyNo,
            strategyStatus: strategyStatus
        }
        await StrategyApi.updateStrategy(idStrategy, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                } else {
                    swalError(res.response?.data?.description)
                }
            }).catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => handleGetStrategy())
    }
    const handleGetStrategy = useCallback(async () => {
        dispatch(setLoading())
        let condition: getStrategy = {
            page: page,
            limit: pageLimit,
        }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: Number(idFiscalYear) }
        await StrategyApi.getStrategy(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setTotalItems(res.data?.result?.meta?.totalItems)
                    setStrategy(res.data?.result?.items)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [page, pageLimit])

    const headCells = [
        {
            id: "RANK", disablePadding: false, align: 'left', label:
                <HeaderTopicTable align='start' text='ยุทธศาสตร์' />
        },
        {
            id: "RANK", disablePadding: false, width: 140, align: 'center', label:
                <HeaderTopicTable minWidth='140px' align='center' text='สถานะ' />
        },
        {
            id: "EDIT", disablePadding: false, width: 100, align: "left", label: ""
        }
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { strategyName, idStrategy, strategyNo, strategyStatus, idStrategyRef } =
            objData;

        const objRenderData = {
            key: no,
            id: idStrategy,
            obj: objData,
            columns: [
                { option: "TEXT", align: "left", label: `${strategyNo}  ${strategyName}` },
                {
                    option: "TEXT", width: 90, align: "left", label:
                        <FilterSelect
                            disabled={permission?.find((list: any) => list?.code === "Strategic.Edit")?.permit === false}
                            headingNormal
                            renderValue={() =>
                                <ListItemText className='relative text-center'>
                                    {strategyStatus === t("STATUS.ACTIVE") ? (
                                        <Typography
                                            className='text-light_success after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                            {t("STATUS.ACTIVE")}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            className='text-danger after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                            {t("STATUS.INACTIVE")}
                                        </Typography>
                                    )}
                                </ListItemText>
                            }

                            label={t('STATUS.LABEL')}
                            selectId="select-strategy-status"
                            value={strategyStatus}
                            labelId="label-strategy-status"
                            onchange={(event: React.ChangeEvent<HTMLSelectElement>) => handleChangeStatusStrategy(idStrategy, objData, event?.target.value)}
                            options={[
                                <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                    <Typography className='text-light_success'><li>{t("STATUS.ACTIVE")}</li></Typography>
                                </MenuItem>,
                                <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                    <Typography className='text-danger'><li>{t("STATUS.INACTIVE")}</li></Typography>
                                </MenuItem>
                            ]}
                        />
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    width: 30,
                    component:
                        <div className='w-full flex justify-end gap-5'>
                            <Button
                                onClick={() => navigate('/auth/setting/tactics', { state: idStrategy })}
                                startIcon={<RemoveRedEyeOutlinedIcon className='text-base_disable cursor-pointer' />}>
                                <Typography className='text-base_secondary'>{t("BUTTON.VIEW")}</Typography>
                            </Button>
                            {permission?.find((list: any) => list?.code === "Strategic.Edit")?.permit === true && (
                                <Button
                                    onClick={() => {
                                        setIdStrategy(idStrategy)
                                        setIdStrategyRef(idStrategyRef)
                                        handleToggleModalEdit()
                                    }}
                                    startIcon={<img src={RouteImage.editPen} />}
                                    sx={disableStyleButtonMui}>
                                    {"แก้ไข"}
                                </Button>
                            )}
                        </div>
                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    useEffect(() => {
        handleGetStrategy()
    }, [page, pageLimit])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            {isShowModal && (
                <ModalCustom
                    enableExit={handleToggleModal}
                    maxHeight='auto'
                    heading={t("BUTTON.ADD")}
                    alignHeader='center'
                    component={
                        <AddStrategy
                            idStrategyRef={idStrategyRef}
                            fetchData={handleGetStrategy}
                            toggleModal={handleToggleModal}
                        />
                    }
                />
            )}
            {isShowModalEdit && (
                <ModalCustom
                    enableExit={handleToggleModalEdit}
                    maxHeight='auto'
                    heading={'เพิ่มยุทธศาสตร์'}
                    alignHeader='center'
                    component={
                        <EditStrategy
                            idStrategy={idStrategy}
                            idStrategyRef={idStrategyRef}
                            fetchData={handleGetStrategy}
                            toggleModal={handleToggleModalEdit}
                        />
                    }
                />
            )}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <section className='flex justify-start items-start md:justify-between flex-col md:flex-row md:items-center gap-3'>
                        <Typography className='text-primary' variant='h4'>
                            {`ปีงบประมาณ ${idFiscalYear === 0 ? '' : idFiscalYear} / ยุทธศาสตร์`}
                        </Typography>
                        {permission?.find((list: any) => list?.code === "Strategic.Create")?.permit === true && (
                            <ButtonOutlined
                                onClick={() => {
                                    handleToggleModal();
                                }}
                                sx={{ maxWidth: "75px" }}
                                startIcon={<img src={RouteImage.addButton} />} >
                                <Typography className='text-primary'>{t("BUTTON.ADD")}</Typography>
                            </ButtonOutlined>
                        )}
                    </section>

                    <section className='mt-8 w-full h-auto'>
                        {strategy && (
                            <TableCustom
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy=""
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={strategy && strategy.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        )}
                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default Strategic